import React from 'react'
import PropTypes from 'prop-types'

const WelcomeComponent = ({title, subtile}) => {
  return (
    <div className='welcome-component'>
      <h2 className='text-ds-h3'>{title}</h2>
      <h4 className='text-ds-body-lg custom-width'>{subtile}</h4>
    </div>
  )
}

WelcomeComponent.propTypes = {
  title: PropTypes.string,
  subtile: PropTypes.string,
}

export default WelcomeComponent
